<ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
<ng-container *ngIf="pendingItems">
  <div class="pending-item-container" *ngIf="pendingItems.length > 0 && !noData; else noItems">
    <button *ngIf="pendingItems.length > 0" type="button"
        [ngClass]="{'slide-prev swiper-button-prev': true, 'slide-arrow' :true}" 
        aria-label="Previous" 
        role="button" 
        style="display: block;">Previous</button>
        <button *ngIf="pendingItems.length > 0" type="button" 
        [ngClass]="{'slide-next swiper-button-next': true, 'slide-arrow': true}" 
        aria-label="Next"
        role="button"
        style="display: block;">Next</button>
      <div  class="swiper-container" [swiper]="config">
        <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let pendingItem of pendingItems;let i=index" (click)="selectPending(pendingItem.ViewID)">
              <div class="card-image text-center">
                <div class="card-pending" [ngStyle]="{'background-color': pendingItem.IconColor}" [id]="'card-pending-' + i">
                  <div class="img-pending">
                    <img src="../../assets/images/{{pendingItem.IconType}}.png">
                  </div>
                  <p class="icon-text">{{ pendingItem.IconText }}</p>
                  <span class="pending-item-count">{{ pendingItem.ItemCount < 100  ? pendingItem.ItemCount : '99+'}}</span>
                </div>
              </div>
            </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
  </div>
  <ng-template #noItems>
    <div class="pending-item-container">
      <div class="no-item-container">
        <p>Well Done! Your tasks are all up to date!</p>
      </div>
    </div>
  </ng-template>
</ng-container>
